// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__0AlHW","option":"SuperSelect_option__V0AE8"};